import { render, staticRenderFns } from "./sellerSection.vue?vue&type=template&id=5dfe058b&scoped=true&"
import script from "./sellerSection.vue?vue&type=script&lang=js&"
export * from "./sellerSection.vue?vue&type=script&lang=js&"
import style0 from "./sellerSection.vue?vue&type=style&index=0&id=5dfe058b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe058b",
  null
  
)

export default component.exports